// extracted by mini-css-extract-plugin
export var deliveryRow = "_sj-a";
export var fixedHeight = "_sj-4";
export var freightLogo = "_sj-9";
export var fullWidth = "_sj-3";
export var priceColumn = "_sj-5";
export var radioSelected = "_sj-7";
export var radioUnselected = "_sj-6";
export var selectedOption = "_sj-2";
export var selectedOptionContainer = "_sj-1";
export var selection = "_sj-0";
export var tallSkeletonText = "_sj-8";